function Character() {
  return (
    <h1>Character</h1>
  )
}

export default Character
